import { actions, selectors } from '@sloyd/store-base';
import { bridge } from '@sloyd/viewer';
import { get } from 'lodash';
import { delay, fork, put, select, takeEvery } from 'saga-ts';
import { $ac, invokeEvent, l } from 'shared-base';
import { customEventChannel } from './channels/channel.customEvent';

export const saga = {
  id: 'sloyd.unity',
  type: 'entity',
  root: root,
  trigger: {
    eventTypes: ['unity'],
  },
};

type Verb =
  | 'progress' //
  | 'updateWackModifiers'
  | 'updateEditorState'
  | 'materialSlotSelected'
  | 'saveDataExported'
  | 'sceneChanged'
  | 'modelLoaded'
  | 'incomingGlb'
  | 'status'
  | 'paletteValuesResponse';

type Action = {
  type: 'MODELS';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  status: status,
  progress: progress,
  updateWackModifiers: updateWackModifiers,
  updateEditorState: updateEditorState,
  saveDataExported: saveDataExported,
  modelLoaded: modelLoaded,
  sceneChanged: sceneChanged,
  materialSlotSelected: materialSlotSelected,
  incomingGlb,
  paletteValuesResponse: paletteValuesResponse,
};

export function* materialSlotSelected(ev: any) {
  try {
    const { data } = ev;
    yield put(actions.currentIds.patch({ slotId: data }));
    invokeEvent('indexSelector', { index: data });
    bridge.setSlotId(data);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* modelLoaded(ev: any) {
  try {
    yield put($ac('UNITY_MODEL_LOADER'));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* status(ev: any) {
  try {
    const { data } = ev;
    const { isLoaded } = data;

    yield put(actions.appState.patch({ isUnityReady: isLoaded }));

    if (isLoaded) {
      yield put($ac('UNITY_READY'));
    }
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* progress(ev: any) {
  try {
    const { data } = ev;
    const { progress } = data;

    if (progress === 1) {
      yield put($ac('UNITY_READY'));
    }

    const isUnityReady = progress === 1;
    yield put(actions.appState.patch({ isUnityReady }));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* incomingGlb(ev: any) {
  const { data } = ev;

  // save binary in indexedDb
  yield delay(100);

  invokeEvent('nav', { path: '/labs/three' });
}

export function* updateWackModifiers(ev: any) {
  const model = yield* select(selectors.single.$currentModel);
  if (!model) return;

  const wackModifiers = get(ev, 'data.Values');
  // yield put(actions.models.patch(model.id, { wackModifiers }));
}

export function* updateEditorState(ev: any) {
  const model = yield* select(selectors.single.$currentModel);
  if (!model) return;

  const parameters = get(ev, 'data.AllOptions');
  // yield put(actions.models.patch(model.id, { parameters }));
}

export function* saveDataExported(ev: any) {}

export function* sceneChanged(ev: any) {}

export function* paletteValuesResponse(ev: any) {}

export function* unity(ev: any) {
  const { verb, data } = ev.data;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.unity ${verb}`);

  // yield* authGuard();

  yield* fork(saga, { verb, data });
}

export function* root() {
  let channel;

  l('saga|saga.auth listening for UNITY custom event');
  channel = customEventChannel('UNITY');
  yield takeEvery(channel, unity);
}
